import { ottApps } from "../data/appData";
import { useNavigate } from "react-router-dom";
import OttRow from "../components/OttRow";
import HeroBanner from "../components/HeroBanner";
import CategoryRow from "../components/CategoryRow";
import LatestReleaseRow from "../components/LatestReleaseRow";
import ActionMovies from "../components/ActionMovies";
import SportsRow from "../components/SportsRow";

export default function Home() {
  const nav = useNavigate();

  return (
    <>
      <HeroBanner />
      <CategoryRow />
     <OttRow
  title="OTT Platforms"
  viewAll
  data={ottApps}
  onClick={(item) => nav(`/movies/${item.id}`)}
  onViewAll={() => nav("/ott")}
/>
      <LatestReleaseRow />
      <SportsRow />
      <ActionMovies />
    </>
  );
}
